<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#9a6b27"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#1e293b" right :timeout="timeout">
      <div class="d-flex align-center justify-space-between text-white" style="font-size: 13px;">
        <span>{{ msg }}</span>
        <v-btn small icon text @click="showsnackbar = false" class="ml-2">
          <v-icon small color="white">mdi-close</v-icon>
        </v-btn>
      </div>
    </v-snackbar>

    <v-layout wrap>
      <v-flex xs12 py-2>
        <v-card class="pro-collapsible-card" elevation="0">
          <!-- Card Header / Collapsible trigger -->
          <div class="card-header-bar d-flex align-center justify-space-between px-4 py-3" @click="show = !show">
            <div class="d-flex align-center">
              <v-icon small color="#64748b" class="mr-2">mdi-keyboard-return</v-icon>
              <span class="section-title">Gold Return / Credit Note</span>
              <span v-if="List && List.length > 0" class="badge-count ml-2">{{ List.length }} items</span>
            </div>
            <div class="d-flex align-center">
              <span class="toggle-hint mr-2">{{ show ? 'Collapse' : 'Expand' }}</span>
              <v-btn icon small class="toggle-btn">
                <v-icon small>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </v-btn>
            </div>
          </div>

          <v-expand-transition>
            <div v-show="show" class="card-body-content px-4 py-3">
              <!-- Bill Search and Customer Metadata Grid -->
              <v-layout wrap class="mb-3">
                <v-flex xs12 sm4 md2 pr-2 pb-2>
                  <label class="field-label">Bill No.</label>
                  <v-autocomplete
                    color="#9a6b27"
                    :items="SearchList"
                    v-model="BillNo"
                    placeholder="Bill No / Customer Name / Mobile"
                    item-text="billNo"
                    item-value="_id"
                    :filter="billFilter"
                    outlined
                    clearable
                    hide-details
                    dense
                    height="38"
                    @input="getBill()"
                    class="pro-input"
                  >
                    <template v-slot:item="{ item }">
                      <div class="py-1">
                        <div class="font-weight-medium">{{ item.billNo }}</div>
                        <div class="text-caption" style="color:#64748b;">
                          {{ item.customerName }}
                          <span v-if="item.mobileNumber"> • {{ item.mobileNumber }}</span>
                        </div>
                      </div>
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-flex xs12 sm4 md2 pr-2 pb-2>
                  <label class="field-label">Bill Date</label>
                  <v-text-field
                    outlined
                    v-model="date"
                    color="#9a6b27"
                    placeholder="Date"
                    dense
                    disabled
                    hide-details
                    height="38"
                    class="pro-input"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm4 md2 pr-2 pb-2>
                  <label class="field-label">Customer Name</label>
                  <v-text-field
                    outlined
                    disabled
                    v-model="saledata.customerName"
                    type="text"
                    color="#9a6b27"
                    placeholder="Customer Name"
                    dense
                    hide-details
                    height="38"
                    class="pro-input"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm4 md2 pr-2 pb-2>
                  <label class="field-label">Mobile Number</label>
                  <v-text-field
                    outlined
                    v-model="saledata.mobileNumber"
                    type="number"
                    disabled
                    color="#9a6b27"
                    placeholder="Mobile"
                    dense
                    hide-details
                    height="38"
                    class="pro-input"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm4 md2 pr-2 pb-2>
                  <label class="field-label">Salesman Code</label>
                  <v-text-field
                    disabled
                    outlined
                    v-model="saledata.staffCode"
                    color="#9a6b27"
                    placeholder="Salesman"
                    dense
                    hide-details
                    height="38"
                    class="pro-input"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm4 md2 pr-2 pb-2>
                  <label class="field-label">Boarding Rate (₹)</label>
                  <v-text-field
                    disabled
                    v-model="goldRate"
                    outlined
                    type="number"
                    color="#9a6b27"
                    placeholder="Rate"
                    dense
                    hide-details
                    height="38"
                    class="pro-input"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <!-- Return Items Table -->
              <div v-if="check2 == true && List && List.length > 0" class="table-container mb-3">
                <v-simple-table dense class="pro-data-table m-stack-table">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th style="width: 48px;" class="text-center">Select</th>
                        <th class="text-left">Item Description</th>
                        <th class="text-left">HSN</th>
                        <th class="text-center" style="width: 100px;">Qty</th>
                        <th class="text-right">Gross Wt (g)</th>
                        <th class="text-right">Stone Wt (g)</th>
                        <th class="text-right">Net Wt (g)</th>
                        <th class="text-right">Total (₹)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(value, i) in List" :key="i" :class="{ 'row-selected': value.checkbox }">
                        <td data-label="Select" class="text-center">
                          <v-checkbox
                            :disabled="(getCountOrSplit(value) == 'Count' && value.quantityoriginal < value.quantity) || (getCountOrSplit(value) == 'Count' && value.quantity < 1)"
                            @click="selectThis(value.checkbox, value._id, value)"
                            v-model="value.checkbox"
                            hide-details
                            color="#9a6b27"
                            class="ma-0 pa-0 d-inline-flex justify-center"
                          ></v-checkbox>
                        </td>
                        <td data-label="Item Description" class="font-weight-medium">
                          <span v-if="value.designId">{{ value.designId.name }} - {{ value.itemId.name }}</span>
                          <span v-else class="text-muted">-</span>
                        </td>
                        <td data-label="HSN">
                          <span v-if="value.designId && value.designId.HSN">{{ value.designId.HSN.hsnCode }}</span>
                          <span v-else class="text-muted">-</span>
                        </td>
                        <td data-label="Qty" class="text-center">
                          <v-text-field
                            :disabled="value.checkbox == true || getCountOrSplit(value) == 'Split'"
                            placeholder="0"
                            color="#9a6b27"
                            type="number"
                            outlined
                            dense
                            :maxValue="value.quantityoriginal"
                            :rules="[maxValueRule(value.quantityoriginal), minValueRule]"
                            @change="cal7(i, value._id)"
                            v-model="value.quantity"
                            hide-details="auto"
                            height="30"
                            class="qty-field"
                          ></v-text-field>
                        </td>
                        <td data-label="Gross Wt (g)" class="text-right">{{ value.grossWeight || '0.00' }}</td>
                        <td data-label="Stone Wt (g)" class="text-right">{{ value.stoneWeight || '0.00' }}</td>
                        <td data-label="Net Wt (g)" class="text-right font-weight-medium">{{ value.netWeight || '0.00' }}</td>
                        <td data-label="Total (₹)" class="text-right font-weight-semibold text-slate-900">
                          ₹{{ value.itemTotalAmount ? Number(value.itemTotalAmount).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00' }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>

              <!-- Empty state when bill selected but no items -->
              <div v-else-if="check2 == true && (!List || List.length === 0)" class="empty-state-card py-6 text-center">
                <v-icon color="#94a3b8" size="32">mdi-package-variant</v-icon>
                <div class="empty-text mt-2">No returnable items found for this bill.</div>
              </div>

              <!-- Summary Totals Pill Row -->
              <div v-if="check2 == true && (returnNetWt || returnTotal)" class="d-flex justify-end align-center flex-wrap mt-3 pt-3 border-top-slate">
                <div v-if="returnNetWt" class="summary-pill mr-3 mb-2">
                  <span class="summary-pill-label">Return Net Wt:</span>
                  <span class="summary-pill-val">{{ Number(returnNetWt).toFixed(3) }} g</span>
                </div>
                <div v-if="returnTotal" class="summary-pill total-pill mb-2">
                  <span class="summary-pill-label">Return Net Amount:</span>
                  <span class="summary-pill-val">₹{{ Number(returnTotal).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span>
                </div>
              </div>
            </div>
          </v-expand-transition>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["title2"],
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showsnackbar: false,
      timeout: 2000,
      msg: null,
      date: null,
      juwellaryId: localStorage.getItem("juwellaryId"),
    taxType:localStorage.getItem("GSTstatus"),
      BillNo:null,
      List: [],
      List1:[],
      saledata: [],
      show: false,
      selected: [],
      selectedItems: [],
      check2:false,
      flag1: false,
      sflag: true,
      returnTotal:null,
      returnNetWt:null,
      newId:null,
      newid2:"",
      newList:[],
      goldRate:"",
      SearchList:[],
    };
  },
  computed: {
    goldRate1() {
      return localStorage.getItem("goldRate");
    },
  },
  mounted() {
    this.getReturns();
  //   this.purchaseItem.boardingRate=this.goldRate1;
  },
  watch: {
  
    title2() {
      this.salesId=this.title2._id;
      console.log("saleid==",this.salesId)
    },
    salesId(){
      this.getData();
    },
    selected() {
      // cal7(i,value._id)
      this.calctotal();
      console.log("4")
    
    },
    returnTotal(){
      console.log("selectedItems=",this.selectedItems)
      console.log("11=",this.newId)
      this.$emit("stepper", {
        ref: "returnItems",
        returngoldRate:this.goldRate,
        returnTotalAmt:this.returnTotal,
        returnNetWt:this.returnNetWt,
        returndata: this.selectedItems,
        returnsalesId: this.newId,
        billNo:this.BillNo,
        customerName:this.saledata.customerName,
        mobileNumber:this.saledata.mobileNumber,
        staffCode:this.saledata.staffCode,
        check1: true,
      });
    },
  },
  methods: {
    getCountOrSplit(value) {
      return (value.purchaseItemId && value.purchaseItemId.countOrSplit) || (value.designId && value.designId.countOrSplit);
    },
    maxValueRule(item) {
      return (value) => {
        if (value > item) {
          return `Maximum value is ${item}`;
        }
        return true;
      };
    },
    minValueRule: (value) => {
      if (value < 1) {
        return 'Minimum value is 1'
      } else {
        return true
      }
    },
    cal7(i,id) {
      if(this.List[i].quantity)
      this.check2=false;
      //calculate netweight
      this.List[i].netWeight=0;
      console.log("quantity==",this.List[i].quantity)
      console.log("itemPerWeight==",this.List[i].itemPerWeight)

      this.List[i].stoneWeight=this.List[i].quantity*this.List[i].purchaseItemId.stoneWeight;
      console.log("newstonewt==",this.List[i].stoneWeight)

      this.List[i].netWeight=this.List[i].quantity*this.List[i].itemPerWeight
      console.log("newtwt==",this.List[i].netWeight)
    
      this.List[i].grossWeight=this.List[i].netWeight+this.List[i].stoneWeight
      console.log("stoneweight==",this.List[i].purchaseItemId.stoneWeight)
      console.log("grossWeight==",this.List[i].grossWeight)
   
        this.List[i].itemTotalAmount =
          this.goldRate * this.List[i].netWeight;
        console.log("goldRate=", this.goldRate);
        console.log("netWeight=", this.List[i].netWeight);
        console.log("total=", this.List[i].itemTotalAmount);

//updating array
      this.newList = this.List;
      console.log("newarray=", this.newList);
      this.List = this.newList
      this.check2=true;
      this.newid2=id;
    },
markAll() {
      if (this.isSelectAll) {
        this.selected = [];
        this.sflag = false;
        for (let i = 0; i < this.savedList.length; i++) {
          this.savedList[i].checkbox = true;
          this.selected.push(this.savedList[i]._id);
        }
        console.log("markeD", this.selected);
        // console.log("Ddata=", this.isSelectAll);
        this.sflag = true;
      } else {
        this.sflag = false;
        for (let i = 0; i < this.savedList.length; i++) {
          this.savedList[i].checkbox = false;
          this.selected = [];
        }
        console.log("Rem", this.selected);
        // console.log("Ddata=", this.isSelectAll);
        this.sflag = true;
      }
    },
    selectThis(val, id, items1) {
      this.isSelectAll = false;
      // console.log("items1=", items1);
      if (val == true) {
        if (this.selected.length > 0) {
          if (!id.includes(this.selected)) {
            this.selected.push(id);
            this.selectedItems.push(items1);
            console.log("ll=");
          }
        } else {
          this.selected.push(id);
          this.selectedItems.push(items1);

        }
      } else {
        var ar = this.selected;
        var aritem = this.selectedItems;
        this.selected = ar.filter((x) => x != id);
        this.selectedItems = aritem.filter((x) => x._id.toString() != id.toString());
      }

      console.log("selected id==", this.selected);
      console.log("selectedItems==", this.selectedItems);
      console.log("savedListCopy==", this.savedListCopy);

    },
calctotal() {
      axios({
        method: "Post",
        url: "/returnitem/calculation",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          currentReturnItems: this.selectedItems,
          salesId: this.salesId,
        },
      })
        .then((response) => {
          if (response.data.status) {
            // this.selected=[];
            this.returnTotal = response.data.totalAmount;
            console.log("this.returnTotal==",this.returnTotal)
            this.returnNetWt = response.data.totalnetweight;
            
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }

          // this.msg = response.data.msg;

          // this.snackbar = true;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getReturns() {
      axios({
        url: "/return/bill/searchlist",
        method: "get",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.SearchList = response.data.saledata;
           
          } else {
           
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    billFilter(item, queryText) {
      var q = (queryText || "").toLowerCase();
      var billNo = (item.billNo || "").toLowerCase();
      var name = (item.customerName || "").toLowerCase();
      var mobile = (item.mobileNumber || "").toLowerCase();
      return billNo.indexOf(q) > -1 || name.indexOf(q) > -1 || mobile.indexOf(q) > -1;
    },
    getBill() {
      this.List1=[];
      this.List=[];
    this.goldRate=this.goldRate1;

      axios({
        url: "/return/bill/search",
        method: "get",
        params: {
          saleId: this.BillNo,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.List1 = response.data.data;
            // this.List = response.data.data;

            this.saledata = response.data.saledata;
            this.testList();
            this.check1=true;
            this.check2=true;
            if (this.List1.length > 0) {
              this.flag1 = true;
            } else {
              this.flag1 = false;
            }
            this.newId = response.data.saledata._id;
            var newdate = response.data.saledata.create_date;
            this.date=this.formatDate(newdate);
            console.log("date=",this.date)
          } else {
            this.check2=false;
            this.goldRate="";
            this.List = [];
            this.saledata = [];
            this.newId = "";
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    testList(){
      for(var i=0;i<this.List1.length;i++){
      this.List1[i].quantityoriginal =
        this.List1[i].quantity;
      }
      this.List=this.List1;
      console.log("List1==", this.List1);

    },
    updateReturnQty(newid2) {
      axios({
        method: "Post",
        url: "/return/edit",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          items:this.newList,
          id:newid2,
        },
      })
        .then((response) => {
          if (response.data.status) {
            // this.selected=[];
            this.returnTotal = response.data.totalAmount;
            console.log("this.returnTotal==",this.returnTotal)
            this.returnNetWt = response.data.totalnetweight;
            
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }

          // this.msg = response.data.msg;

          // this.snackbar = true;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      // var hours = dt.getHours();
      // var minutes = dt.getMinutes();
      dt = dt.toString();
      // var ampm = hours >= 12 ? "pm" : "am";
      // hours = hours % 12;
      // hours = hours ? hours : 12;
      // minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = day + " " + dt.slice(4, 7) + " " + year;
      //  +
      // " , " +
      // hours +
      // ":" +
      // minutes +
      // " " +
      // ampm;

      return strTime;
    },
  },
};
</script>

<style scoped>
.pro-collapsible-card {
  background: #ffffff !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 10px !important;
  overflow: hidden;
  transition: all 0.2s ease;
}

.card-header-bar {
  background-color: #f8fafc;
  cursor: pointer;
  border-bottom: 1px solid #e2e8f0;
  user-select: none;
}

.card-header-bar:hover {
  background-color: #f1f5f9;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  letter-spacing: 0.2px;
}

.badge-count {
  font-size: 11px;
  font-weight: 600;
  background-color: #fef3c7;
  color: #92400e;
  padding: 2px 8px;
  border-radius: 9999px;
  border: 1px solid #fde68a;
}

.toggle-hint {
  font-size: 12px;
  color: #64748b;
}

.field-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #64748b;
  margin-bottom: 4px;
}

.pro-input :deep(.v-input__slot) {
  min-height: 38px !important;
  background: #ffffff !important;
  border-color: #cbd5e1 !important;
}

.pro-input :deep(fieldset) {
  border-color: #cbd5e1 !important;
}

.pro-input:hover :deep(fieldset) {
  border-color: #94a3b8 !important;
}

.pro-input.v-input--is-focused :deep(fieldset) {
  border-color: #9a6b27 !important;
  border-width: 1.5px !important;
}

.qty-field :deep(.v-input__slot) {
  min-height: 30px !important;
  max-width: 80px;
  margin: 0 auto;
  padding: 0 6px !important;
}

.qty-field :deep(input) {
  text-align: center;
  font-size: 13px;
}

.table-container {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}

.pro-data-table table {
  width: 100%;
  border-collapse: collapse;
}

.pro-data-table th {
  background-color: #f8fafc !important;
  color: #475569 !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  padding: 10px 12px !important;
  border-bottom: 1px solid #e2e8f0 !important;
}

.pro-data-table td {
  font-size: 13px !important;
  color: #334155 !important;
  padding: 8px 12px !important;
  border-bottom: 1px solid #f1f5f9 !important;
}

.row-selected {
  background-color: #fffbeb !important;
}

.text-muted {
  color: #94a3b8;
}

.empty-state-card {
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  background-color: #f8fafc;
}

.empty-text {
  font-size: 13px;
  color: #64748b;
}

.border-top-slate {
  border-top: 1px solid #f1f5f9;
}

.summary-pill {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  padding: 6px 14px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.summary-pill-label {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
}

.summary-pill-val {
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
}

.total-pill {
  background: #eff6ff;
  border-color: #bfdbfe;
}

.total-pill .summary-pill-label {
  color: #1e40af;
}

.total-pill .summary-pill-val {
  color: #1e3a8a;
  font-size: 15px;
}
</style>

